import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable, View } from 'react-native';
import { theme } from './shared';
import type { ProfileNamespace } from './shared';

export function ProfileStatsAndReport({
  emojiStatsElements,
  isMyself,
  isPlace,
  isReportingUser,
  ns,
  onReport,
}: {
  emojiStatsElements: (React.ReactElement | null)[];
  isMyself: boolean;
  isPlace: boolean;
  isReportingUser: boolean;
  ns: ProfileNamespace;
  onReport: () => void;
}) {
  const { t } = useTranslation();
  return (
    <>
      <Column style={{ marginTop: theme.spacing['spacing.general.x5'] }}>
        <View style={{ flexWrap: 'wrap', flexDirection: 'row' }}>
          {emojiStatsElements.map((element) => (
            <View
              key={element?.key ?? 'requests-placeholder'}
              style={{
                flexBasis: '50%',
                marginBottom: theme.spacing['spacing.general.x3'],
                paddingHorizontal: theme.spacing['spacing.general.x2'],
              }}
            >
              {element}
            </View>
          ))}
        </View>
      </Column>
      {!isMyself && !isPlace ? (
        <Column alignItems="center">
          <Pressable disabled={isReportingUser} onPress={onReport} style={{ opacity: isReportingUser ? 0.5 : 1 }}>
            <Text variant="bodyBase" color="text.placeholder" style={{ textDecorationLine: 'underline' }}>
              {t('reportUser', { ns })}
            </Text>
          </Pressable>
        </Column>
      ) : null}
    </>
  );
}
